import AutoTrackBeacon from '@tencent/autotracker-beacon-oa';

export const autoInstance = new AutoTrackBeacon({
  report: {
    appkey: '0WEB06C0OORDG98P', // 从datahub获取的appkey
    commonParams: {
      // 自定义的上报公共参数, 每条上报都会携带
      uid: '925280542__twj', // uid是业务用户身份标示
    },
  },
  uselib: ['element'], // 全埋点自动上报配置，详见“上报方式”部分
});

// 插件式的使用方式，详见下文“插件使用”部分
autoInstance.config('Click', {
  autoSelector: ['[class^=click-]'], // 全埋点自动上报配置，详见“上报方式”部分
});

// 初始化，注意这里要显式调用init方法
autoInstance.init().then(() => {
  console.log('beacon初始化成功');
});
